import type { IComponentController } from "angular";
import { differenceBy } from "lodash";
import { map } from "rxjs/operators";

import type { IEquipmentFunctionalityTypeSlim } from "App/Modules/Models";
import type { IEquipmentFunctionalityTypesRepository } from "App/Modules/Repositories";

export default class FindAddFunctionalityComponentController implements IComponentController {
    public static $inject: string[] = ["irEquipmentFunctionalityTypesRepository"];

    public newFunctionality: (params: { searchString: string }) => void;

    public selectFunctionality: (params: { functionality: IEquipmentFunctionalityTypeSlim }) => void;

    public selectedFunctionality: IEquipmentFunctionalityTypeSlim;

    public addedFunctionalities: IEquipmentFunctionalityTypeSlim;

    public canAddUFunctionality: boolean;

    public clearAfterAdd: boolean;

    public hideTitle: boolean;

    private searchString: string;

    constructor(private readonly equipmentFunctionalityTypesRepository: IEquipmentFunctionalityTypesRepository) {}

    public functionalitySearch(value: string) {
        return this.equipmentFunctionalityTypesRepository
            .search(value)
            .pipe(
                map((result) => {
                    this.searchString = value;

                    // todo: Below is maybe a bug? "as any" added since types don't match and call doesn't match signature.
                    const suggested = differenceBy(result.data, this.addedFunctionalities as any, "id").slice(0, 8);

                    if (this.canAddUFunctionality || this.canAddUFunctionality === undefined) {
                        suggested.push({
                            displayName: "",
                            id: null,
                        } as IEquipmentFunctionalityTypeSlim);
                    }

                    return suggested;
                }),
            )
            .toPromise();
    }

    public functionalitySelected(functionality: IEquipmentFunctionalityTypeSlim) {
        if (!functionality.id) {
            if (this.newFunctionality) {
                this.newFunctionality({ searchString: this.searchString });
            }
        } else if (this.selectFunctionality) {
            this.selectFunctionality({ functionality });
        }
        if (this.clearAfterAdd) {
            this.selectedFunctionality = null;
        }
    }
}
